$('[data-type]').on('change', function() {
  var type_id = $(this).val();

  if (type_id !== '') {
    $.getJSON('/types/' + parseInt(type_id) + '/inspection_levels', function(result) {
      $('[data-inspection-level]').each(function() {
        var inspection_level_id = parseInt($(this).attr('data-inspection-level')),
            found = $.inArray(inspection_level_id, result) > -1;

        if (found) {
          $(this).find('input').prop('disabled', false);
        } else {
          $(this).find('input').val('').prop('disabled', true);
        }
      });
    });
  }
}).trigger('change');
